export type TermsDocumentType = "gwp_terms" | "hops_privacy_policy";
export type TermsLanguage = "en" | "bg" | "ru";

export interface TermsAcceptance {
  applicantId: string;
  applicantEmail: string;
  documentType: TermsDocumentType;
  documentVersion: string;
  language: TermsLanguage;
  acceptedAt: string;
  optionalNewServicesAccepted?: boolean;
}

export interface TermsAcceptanceDoc {
  id: string;
  acceptance: TermsAcceptance;
}

export interface TermsDocumentMeta {
  type: TermsDocumentType;
  title: string;
  version: string;
  filePrefix: string;
}

export const TERMS_LANGUAGES: TermsLanguage[] = ["en", "bg", "ru"];

export const TERMS_DOCUMENTS: Record<TermsDocumentType, TermsDocumentMeta> = {
  gwp_terms: {
    type: "gwp_terms",
    title: "GWP Terms & Conditions",
    version: "1.0",
    filePrefix: "GWP_Terms",
  },
  hops_privacy_policy: {
    type: "hops_privacy_policy",
    title: "HOPS Privacy Policy",
    version: "1.0",
    filePrefix: "HOPS_Privacy_Policy",
  },
};

export const resolveTermsLanguage = (language?: string | null): TermsLanguage => {
  if (language && TERMS_LANGUAGES.includes(language as TermsLanguage)) {
    return language as TermsLanguage;
  }

  return "en";
};

export const getTermsHtmlPath = (documentType: TermsDocumentType, language: TermsLanguage) => {
  const filePrefix = TERMS_DOCUMENTS[documentType].filePrefix;
  return `/terms/${filePrefix}_${language.toUpperCase()}.html`;
};
